import { render, staticRenderFns } from "./v2.vue?vue&type=template&id=f8f10ae6&scoped=true&"
import script from "./v2.vue?vue&type=script&lang=js&"
export * from "./v2.vue?vue&type=script&lang=js&"
import style0 from "./v2.vue?vue&type=style&index=0&id=f8f10ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f10ae6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8f10ae6')) {
      api.createRecord('f8f10ae6', component.options)
    } else {
      api.reload('f8f10ae6', component.options)
    }
    module.hot.accept("./v2.vue?vue&type=template&id=f8f10ae6&scoped=true&", function () {
      api.rerender('f8f10ae6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/Top10List/v2.vue"
export default component.exports